import React from "react";
import {Link} from "react-router-dom";
import Gravatar from "react-gravatar";
import LogoutButton from "../LogoutButton/LogoutButton";
import useAppUser from "../../hooks/useAppUser/useAppUser";
import UserInfo from "../UserInfo/UserInfo";

function UserMenu() {
	const user = useAppUser();
	return (
		<div className="dropdown dropdown-end">
			<div tabIndex={0} role="button" className="btn btn-ghost btn-circle" aria-label="User Menu">
				<Gravatar email={user.email} protocol="https://" size={24}/>
			</div>
			<ul tabIndex={0}
			    className="dropdown-content menu bg-base-100 text-base-content rounded-box border border-accent z-10 w-72 p-4">
				<li className="bg-base-200 rounded-t">
					<UserInfo />
				</li>
				{
					user.isAdmin &&
					<li><Link to="admin">Admin</Link></li>
				}
				<li><Link to="account">Your Account</Link></li>
				<li><Link to="plan">Your Plan</Link></li>
				<li><Link to="invitations">Your Invitations</Link></li>
				<li><Link to="templates">Your Templates</Link></li>
				<li><LogoutButton /></li>
			</ul>
		</div>
	);
}

export default UserMenu;
